import { useDsaTags } from "../../hooks/useDsaTags";
import "./DsaTags.scss";

interface DsaTagFilterPillsProps {
  selectedTagIds: number[];
  onChange: (tagIds: number[]) => void;
}

export default function DsaTagFilterPills({ selectedTagIds, onChange }: DsaTagFilterPillsProps) {
  const { tags } = useDsaTags();
  if (tags.length === 0) return null;

  function toggle(tagId: number) {
    onChange(selectedTagIds.includes(tagId)
      ? selectedTagIds.filter(id => id !== tagId)
      : [...selectedTagIds, tagId]);
  }

  return <div className="dsa-tag-pills">
    <span className="label">Tags</span>
    <span className={`pill ${selectedTagIds.length === 0 ? "active" : ""}`} onClick={() => onChange([])}>All</span>
    {tags.map(t => <span
      key={t.id}
      className={`pill ${selectedTagIds.includes(t.id!) ? "active" : ""}`}
      onClick={() => toggle(t.id!)}
    >{t.name}</span>)}
  </div>;
}
